<template>
  <div class="commentswriteinput clearfix">
    <p class="secondary_title ">{{$t('comment.your_name')}}</p>
    <input class="page_text_font" type="text" @blur="required(review.name,'name')" v-model="review.name" id="name" />
    <div class="required_tips page_text_font">{{$t('comment.this_field_is_required')}}</div>
    <p class="tips page_text_font"></p>
    <p class="secondary_title ">{{$t('comment.email')}}</p>
    <input class="page_text_font" type="email" @blur="required(review.email,'email')" v-model="review.email" id="email" />
    <div class="required_tips page_text_font">{{$t('comment.enter_a_valid_email')}}</div>
    <p class="tips page_text_font"></p>
    <p class="secondary_title ">{{$t('comment.rating')}}</p>
    <div class="starRating">
      <v-comments-star ref="comments_star"></v-comments-star>
    </div>
    <p class="secondary_title ">{{$t('comment.body_of_review')}}</p>
    <textarea
    class="page_text_font"
      :placeholder="$t('comment.write_your_comment')"
      v-model="review.content"
      @keyup="maxnum"
      @change="maxnum"
      @blur="required(review.content,'content')"
      id="content"
    ></textarea>
    <div class="required_tips page_text_font">{{$t('comment.this_field_is_required')}}</div>
    <div class="upload_box page_text_font">
      <el-upload
        :action="API.comment_attachments"
        :on-preview="handlePictureCardPreview"
        :on-success="upload_success"
        :on-remove="upload_remove"
        :on-exceed="exceed"
        :before-upload="beforeAvatarUpload"
        :file-list="file_list"
        list-type="picture-card"
        :multiple="true"
        :limit="5"
        name="files[]"
      >
        <div class="el-upload__text page_text_font">+{{$t('comment.photo')}}</div>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt />
      </el-dialog>
    </div>
    <button class="submit_review main_button secondary_title" @click="submit_review" :disabled="disabled">{{$t('comment.submit_review')}}</button>
  </div>
</template>
<script>
// import API from "../../../API";
import vCommentsStar from "./commentsstar";
export default {
  props: ["product_id"],
  data() {
    return {
      value1: 5,
      imageUrl: "",
      review: {
        name: "",
        email: "",
        rating: "5",
        content: "",
        gallery: []
      },
      API,
      dialogVisible: false,
      dialogImageUrl: "",
      gallery: [],
      form_test: ["name", "email", "content"],
      file_list: [],
      disabled:false
    };
  },

  methods: {
    maxnum(){
        if (this.review.content.length>=2000) {
          this.review.content=this.review.content.substring(0,2000);
        }
    },
    //限制图片格式
    beforeAvatarUpload(file) {
      console.log(file.type);
      const isJPG =
        file.type === "image/jpeg" || file.type === "image/png" ||file.type === "image/gif" ||file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 8;
      if (!isLt2M) {
        this.$message.error(this.$t('comment.8MB'));
      }
      if (!isJPG) {
        this.$message.error(this.$t('comment.upload_images'));
      }
      return isJPG && isLt2M;
    },
    //超出最大数量
    exceed() {
      this.$message.error(this.$t('comment.maximum5'));
    },
    upload_remove(file, fileList) {
      if (file.response&&file.response.length) {
        this.gallery.splice(this.gallery.indexOf(file.response[0]), 1);
      }
    },
    upload_success(response, file, fileList) {
      console.log(response);
      if (!this.gallery.includes(response[0])) {
        this.gallery.push(response[0]);
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    required(value, field) {
      let onOff = false;
      let reg = /^([0-9A-Za-z\-_\.]+)@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (value == "" || (field == "email" && !reg.test(value))) {
        onOff = true;
      }
      if (onOff) {
        this.$("#" + field).addClass("required");
        return false;
      } else {
        this.$("#" + field).removeClass("required");
        return true;
      }
    },
    async submit_review() {
      let post_off = true;
      this.form_test.forEach(item => {
        let onOff = this.required(this.review[item], item);
        if (!onOff) {
          post_off = false;
        }
      });
      if (post_off) {
        try {
          this.disabled=true;
          this.review.gallery = this.gallery;
          this.review.rating = this.$refs.comments_star.value;
          let res = await this.$axios.post(
            `/api/store/products/${this.product_id}/reviews`,
            this.review
          );
          this.disabled=false;
          console.log(res);
          if (res.status == "200") {
            this.$(".commentswriteinput").hide();
            this.$(".review-ok").show();
            res.data.help_show = true;
            res.data.abuse_show = true;
            res.data.add_comment = true;
            res.data.comment_approved = true;
            this.$store.dispatch("change_new_comment", res.data);
            this.review.name = "";
            this.review.email = "";
            this.$refs.comments_star.value = 5;
            this.review.content = "";
            this.review.gallery = [];
            this.gallery = [];
            this.file_list = [];
          }
        } catch (error) {
          this.disabled=false;
          console.log("error", error.response);
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            this.$message.error(error.response.data.message);
          }
        }
      }
    },
    toggle() {
      this.$(".commentswriteinput").slideToggle(500);
      if (window.performance.navigation.type == 2) {
        this.form_test.forEach((item) => {
        this.review[item]=this.$('#'+item).val();
        });
      }
    }
  },
  components: {
    vCommentsStar
  }
};
</script>
<style  lang='scss'>
.commentswriteinput {
  display: none;
  padding-bottom: 50px;
  .required {
    border: 1px solid #ff4d4f !important;
  }
  .required + .required_tips {
    display: block;
  }
  .required_tips {
    display: none;
    color: #ff4d4f;
    font-size: 14px;
    padding-top: 0;
    margin-top: 8px;
  }
  p {
    font-size: 14px !important;
    color: #000000;
    padding: 10px 0 8px;
    margin: 0;
  }
  input {
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 4px;
    height: 40px;
    padding: 0 10px;
    box-sizing: border-box;
    font-size: 12px;
  }
  textarea {
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 4px;
    height: 80px;
    padding: 10px;
    box-sizing: border-box;
    font-size: 14px;
  }
  .tips {
    padding: 8px 0;
  }
  .starRating {
    padding-bottom: 10px;
  }
  .upload_box {
    padding: 20px 0;
    .el-upload-list {
      .el-upload-list__item {
        zoom: 0.66;
        .el-upload-list__item-actions,
        .el-upload-list__item-status-label {
          zoom: 1.4 !important;
        }
      }
    }
    div {
      .el-upload--picture-card {
        width: 100px;
        height: 100px;
        input{
          display: none;
        }
        .el-upload__text {
          line-height: 100px;
        }
      }
    }
  }
  .submit_review {
    -webkit-tap-highlight-color: transparent;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    transition: 0.1s;
    font-weight: 500;
    padding: 13px 20px;
    height: 44px;
    font-size: 14px;
    border-radius: 4px;
    color: rgba(255, 255, 255, 1);
    border-color: rgba(0, 0, 0, 1);
    background-color: rgba(0, 0, 0, 1);
    display: block;
    float: right;
    text-transform: uppercase;
    &:hover {
      opacity: 0.9;
    }
  }
  .el-dialog__wrapper {
    .el-dialog {
      width: 420px !important;
      max-width: 100% !important;
    }
  }
}
@media screen and (max-width: 575px) {
  .commentswriteinput {
    p,
    textarea {
      font-size: 21px !important;
    }
    textarea {
      height: 136px;
    }
    .submit_review {
      width: 100%;
      margin-top: 8px;
    }
  }
}
</style>